<template>
          <!-- <div style="float:right;margin-right:1rem;">{{getCssValue(element.name, property)}}</div> -->
<div class="inline-block w-100">
  <input class="patch float-right" type="color" v-model="color" @change="updateColor" />
  <input class="txt float-right" v-model="color" @change="updateColor" @focus="$event.target.select()"/>
</div>
</template>
<script>

export default {
  name: "ColorSelector",
  props: ["cssVar", "initialColor"],

  data() {
    return {
      color: this.initialColor,
    };
  }, // end data

  methods: {
    updateColor() {
      this.$root.$emit("update-element-color", this.cssVar, this.color)
    }
  }, // end methods
};
</script>
<style scoped>
.patch {
display: inline-block;
  width: 40px;
  height: 20px;
  border: 1px solid gray;
  margin-bottom: -5px;
}
.txt {
  width: 80px;
  height: 20px;
  font-family: "Courier New", Courier, monospace; /* fallback for IE */
  font-family: value; /* fallback for IE */
  font-family: var(--monospace-font-family);
}
</style>